/* global axios */
import ApiClient from './ApiClient';

const getTimeOffset = () => -new Date().getTimezoneOffset() / 60;

class ReportsAPI extends ApiClient {
  constructor() {
    super('reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getReports({
    metric,
    from,
    to,
    type = 'account',
    id,
    groupBy,
    businessHours,
    selectedTeamIds,
    selectedAgentIds,
    selectedInboxIds,
  }) {
    return axios.get(`${this.url}`, {
      params: {
        metric,
        since: from,
        until: to,
        type,
        id,
        group_by: groupBy,
        business_hours: businessHours,
        timezone_offset: getTimeOffset(),
        team_ids: selectedTeamIds,
        agent_ids: selectedAgentIds,
        inbox_ids: selectedInboxIds,
      },
    });
  }

  // eslint-disable-next-line default-param-last
  getSummary(since, until, type = 'account', id, groupBy, businessHours) {
    return axios.get(`${this.url}/summary`, {
      params: {
        since,
        until,
        type,
        id,
        group_by: groupBy,
        business_hours: businessHours,
        timezone_offset: getTimeOffset(),
      },
    });
  }

  getConversationMetric({
    type,
    page,
    limit,
    selectedTeamIds,
    orderBy,
    orderDirection,
    selectedAgentIds,
    selectedInboxIds,
    selectedStatusIds,
    selectedBusyAvailabilityReasonIds,
  }) {
    return axios.get(`${this.url}/conversations`, {
      params: {
        type: type ?? 'account',
        page: page ?? 1,
        limit: limit ?? 25,
        team_ids: selectedTeamIds,
        order_by: orderBy,
        order_direction: orderDirection,
        agent_ids: selectedAgentIds,
        inbox_ids: selectedInboxIds,
        agent_status: selectedStatusIds,
        availability_reason_ids: selectedBusyAvailabilityReasonIds,
      },
    });
  }

  getAgentReports({ from: since, to: until, businessHours }) {
    return axios.get(`${this.url}/agents`, {
      params: { since, until, business_hours: businessHours },
    });
  }

  getTicketMetricsReports({ from: since, to: until }) {
    return axios.get(`${this.url}/ticket_metrics`, {
      params: { since, until },
    });
  }

  getConversationTrafficCSV() {
    return axios.get(`${this.url}/conversation_traffic`, {
      params: { timezone_offset: getTimeOffset() },
    });
  }

  getLabelReports({ from: since, to: until, businessHours }) {
    return axios.get(`${this.url}/labels`, {
      params: { since, until, business_hours: businessHours },
    });
  }

  getInboxReports({ from: since, to: until, businessHours }) {
    return axios.get(`${this.url}/inboxes`, {
      params: { since, until, business_hours: businessHours },
    });
  }

  getTeamReports({ from: since, to: until, businessHours }) {
    return axios.get(`${this.url}/teams`, {
      params: { since, until, business_hours: businessHours },
    });
  }

  getBotMetrics({ from, to } = {}) {
    return axios.get(`${this.url}/bot_metrics`, {
      params: { since: from, until: to },
    });
  }

  getBotSummary({ from, to, groupBy, businessHours } = {}) {
    return axios.get(`${this.url}/bot_summary`, {
      params: {
        since: from,
        until: to,
        type: 'account',
        group_by: groupBy,
        business_hours: businessHours,
      },
    });
  }

  getInboxMetrics({
    selectedTeamIds,
    selectedAgentIds,
    selectedInboxIds,
  } = {}) {
    return axios.get(`${this.url}/inbox_metrics`, {
      params: {
        team_ids: selectedTeamIds?.join(','),
        agent_ids: selectedAgentIds?.join(','),
        inbox_ids: selectedInboxIds?.join(','),
      },
    });
  }
}

export default new ReportsAPI();
